import { getHttpClient } from "@/http-client";
import { setPaymentFromRequest } from "@/models/Payment";

const baseUrl = "api/boss/payment-chargebacks";
export async function createChargeback(params) {
  const { data } = await getHttpClient().post(`${baseUrl}`, params);
  return setPaymentFromRequest(data.payment);
}
